"use strict";
exports.__esModule = true;
exports.ExtraStore = void 0;
var akita_1 = require("@datorama/akita");
exports.ExtraStore = akita_1.createStore({ hotelExtras: [], roomExtras: {} }, { name: 'extra' });
//# sourceMappingURL=extra.store.js.map